<template>
    <div class="tasks-list-wrapper">
        <h1>{{$t('tests.wizard.image_step.headline')}}</h1>
        <div class="file-upload-holder">
            <b-form-group>
                <b-input-group>
                    <b-input-group-prepend :is-text="true">
                        <em class="icon-url"></em>
                    </b-input-group-prepend>

                    <b-form-input v-model="$parent.test.url" :disabled="showScraperProgress"
                                  :placeholder="$t('tests.wizard.image_step.url_placeholder')"></b-form-input>

                    <b-input-group-append :is-text="true" v-if="isUrlValid === true">
                        <em class="icon-check-url"></em>
                    </b-input-group-append>

                    <b-input-group-append :is-text="true"  v-if="isUrlValid === false" v-b-tooltip.hover :title="urlStatusMessage">
                        <em class="icon-alert" ></em>
                    </b-input-group-append>

                    <b-input-group-append :is-text="true" v-if="isUrlBeingChecked">
                        <b-spinner small></b-spinner>
                    </b-input-group-append>
                </b-input-group>

                <div class="mt-2" v-if="showScraperProgress">
                    <b-progress :value="scraperProgress" :max="100" animated></b-progress>
                </div>

                <b-form-invalid-feedback :force-show="true" v-if="$parent.errors.url">{{$parent.errors.url}}
                </b-form-invalid-feedback>
                <b-form-invalid-feedback :force-show="true" v-if="isUrlValid === true && $parent.errors.image">
                    {{$parent.errors.image}}
                </b-form-invalid-feedback>
                <span class="text-muted small">{{$t('tests.url_hint')}}</span>
            </b-form-group>

            <b-form-group>
                <b-form-file accept="image/jpeg, image/png, image/gif" placeholder="" browse-text=" "
                             drop-placeholder="" ref="fileInput1" v-model="$parent.test.imageToUpload"></b-form-file>
                <div class="input-file-box">
                    <transition-group appear name="switch-fade">
                        <div class="box box-uploaded" v-if="$parent.test.imageToUpload" key="1">
                            <em class="icon-uploading"></em>
                            <span class="filename overflow-hidden">{{ $parent.test.imageToUpload ? $parent.test.imageToUpload.name : '' }}</span>
                            <strong class="text-danger" v-if="$parent.errors.attachments || $parent.errors.image"> {{
                                $parent.errors.attachments || $parent.errors.image }}</strong>
                            <strong class="success" v-else>{{$t('tests.wizard.image_step.image_success')}}</strong>
                        </div>
                        <div class="box" v-else key="2">
                            <em class="icon-upload"></em>
                            <p v-html="$t('tests.wizard.image_step.image_uploader')"></p>
                        </div>
                    </transition-group>
                </div>
            </b-form-group>

            <tests-wizard-buttons-block buttonBlockClass="step-btn1" :next="save"
                                        :isButtonDisabled="isButtonDisabled"></tests-wizard-buttons-block>
        </div>
    </div>

</template>

<script>
    import {url} from '../../mixins/url';

    export default {
        name: 'tests-wizard-image-step',
        mixins: [url],
        data() {
            return {
                isUrlValid: null,
                urlStatus: null,
                isUrlBeingChecked: false,
                scraperProgress: 0,
                showScraperProgress: false,
            };
        },
        watch: {
            '$parent.test.url': {
                deep: true,
                handler() {
                    this.validateUrl();
                }
            },
            '$parent.test.imageToUpload': {
                handler() {
                    this.$emit('setImageError', null);
                    if (this.$parent.test.imageToUpload && this.$parent.test.imageToUpload.type !== 'image/jpeg' && this.$parent.test.imageToUpload.type !== 'image/png' && this.$parent.test.imageToUpload.type !== 'image/gif') {
                        this.$emit('setImageError', this.$t('validation.file_type'));
                    }
                    this.$parent.test.url = null;
                }
            }
        },
        computed: {
            isButtonDisabled() {
                if (this.showScraperProgress) {
                    return true;
                }
                if (this.$parent.test.id && ((this.$parent.test.url && this.$parent.test.image_url) || this.$parent.test.image_url)) {
                    // [Nick] Allow next step in edit mode
                    return false;
                }
                return !(this.$parent.test.url && this.isUrlValid) && (!this.$parent.test.imageToUpload || !!this.$parent.errors.attachments || !!this.$parent.errors.image);
            },
            urlStatusMessage() {
                if (!this.urlStatus) {
                    return '';
                }
                const translations = this.$t('tests.url_statuses');
                if (translations.hasOwnProperty(this.urlStatus)) {
                    return translations[this.urlStatus];
                }

                return translations.unknown;
            }
        },
        methods: {
            validateUrl: _.debounce(function () {

                this.isUrlValid = null;
                const url = this.$parent.test.url;
                if (!url) {
                    return;
                }
                this.isUrlBeingChecked = true;
                this.checkUrl(url).then(result => {
                    this.isUrlValid = result.isValid;
                    this.urlStatus = result.urlStatus;
                }).finally(() => {
                    this.isUrlBeingChecked = false;
                });
            }, 500),
            runScraperProgress() {
                this.scraperProgress = 0;
                this.showScraperProgress = true;
                const period = process.env.MIX_PSEUDO_PROGRESS || 15;

                let timer = setInterval(() => {
                    this.scraperProgress = this.scraperProgress + 1;
                    if (this.scraperProgress >= 95) {
                        clearInterval(timer);
                    }
                }, parseInt(period) * 10);
            },
            save() {
                if (this.$parent.test.url) {
                    this.runScraperProgress();
                }
                this.$parent.saveTest(
                    () => this.scraperProgress = 100,
                    () => this.showScraperProgress = false
                );
            }
        }
    }
</script>

<style scoped>

</style>
